import CustomComponent from '../CustomComponent';

export class FormModal extends CustomComponent {
	static key = 'lta-form-modal';

	static get observedAttributes() {
		return ['labelledby', 'classes', 'is-full-screen', 'stripes'];
	}

	get contentEl() {
		return this.querySelector('.lta-form-modal__content');
	}

	get modalEl() {
		return this.querySelector('.lta-modal');
	}

	render(children) {
		const labelledby = this.props?.labelledby || '';
		const classes = this.props?.classes || '';
		const stripes = this.props?.stripes || '';
		const isFullScreen = this.props?.isFullScreen !== 'false';
		const classNames = ['lta-modal', classes].filter(Boolean).join(' ');
		const classListDialog = ['lta-modal-dialog', isFullScreen ? 'lta-modal-fullscreen' : '']
			.filter(Boolean)
			.join(' ');
		const contentClassNames = [
			'lta-modal-content',
			stripes ? `lta-color-splash--${stripes}` : ''
		]
			.filter(Boolean)
			.join(' ');

		return `
			<div class="${classNames}" tabindex="-1" aria-labelledby="${labelledby}" aria-hidden="true">
				<div class="${classListDialog}">
					<div class="${contentClassNames}">
						<section class="lta-form-modal__step">
							<div class="l-grid lta-form-modal__display-grid">
								<div class="l-lta-grid">
									<div class="g-col-12 g-col-md-3 g-col-xl-4"></div>
									<div class="g-col-12 g-col-md-6 g-col-xl-4">
										<div class="xl:u-mt-0 md:u-mt-6">
											<lta-error-snackbar
												class="lta-form-modal__error-snackbar"
												classes="u-mb-3"
												hidden
											></lta-error-snackbar>
											<div class="lta-form-modal__content">
												${children}
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		`;
	}
}

export default FormModal;
